import React, { useState, useEffect } from "react";
import Styled from "./styles";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import action from "../../../redux/action";

const FileUploadInput = ({
  helperText,
  formId,
  name,
  label,
  InputLabelProps = {},
  ...props
}) => {
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const dynamicForms = useSelector(
    ({ dynamicForms }) => dynamicForms?.[formId]
  );
  const onChangeHandler = (e) => {
    let value = "";
    if (!e?.target?.name) {
      value = e.target.files[0];
    } else {
      name = e?.target?.name;
      value = e?.target?.value;
    }
    dispatch(action.passedFormValidation(false, name, formId));
    let errorFlag = false;
    dispatch(action.updateDynamicFormFields(name, value, formId));
    if (dynamicForms?.fieldsObj?.[name]?.required && !value) {
      errorFlag = true;
    } else {
      errorFlag = false;
    }
    setError(errorFlag);
    if (!errorFlag) {
      dispatch(action.passedFormValidation(!errorFlag, name, formId));
    }
  };

  useEffect(() => {
    if (dynamicForms?.submit === true) {
      const e = {};
      e.target = {
        name: dynamicForms?.fieldsObj?.[name].name,
        value: dynamicForms?.inputValObjs?.[name],
      };
      onChangeHandler(e);
    }
  }, [dynamicForms?.submit]);

  const showPreview=()=>{
    if(dynamicForms?.inputValObjs?.[name]){
      if(typeof dynamicForms?.inputValObjs?.[name]==='string'){
        return `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_UPLOADS}${dynamicForms?.inputValObjs?.[name]}`;
      }else{
        return URL.createObjectURL(dynamicForms?.inputValObjs?.[name]);
      }
    }
  }
  return (
    <Styled >
      <input onChange={onChangeHandler} {...props} />
      {dynamicForms?.inputValObjs?.[name] && (
        <img
          style={{ width: "200px", height: "auto" }}
          src={showPreview()}
        />
      )}
      <br></br>
      <label htmlFor="raised-button-file">
        <Button variant="contained" component="span" className={`${error?'error-input':''}`}>
          {label}
        </Button>
        {error && <span className="error-span">{helperText} </span>}
      </label>
    </Styled>
  );
};

export default FileUploadInput;
